<template>
    <div id="faqs-app">
        <form ref="form" @submit.prevent="submit" novalidate>
            <label for="q">Ask a question:</label>
            <input type="text" id="q" v-model="question" name="q" placeholder="What is your question?" required>
            <input type="submit" value="Submit">
            <a href="#" @click.prevent="showAll" style="display:inline-block;margin-left:10px">Show All</a>
        </form>
        <template v-if="submitted && !loading && results.length > 0">
            <ul class="accordion" data-accordion data-allow-all-closed="true" ref="result_list">
                <li v-for="(res, idx) in results" :key="idx" class="accordion-item" data-accordion-item role="presentation">
                    <!--
                    <p><strong>{{ res.question }}</strong></p>
                    <p v-html="formatAnswer(res.answer)"></p>
                    -->
                    <a href="#" class="accordion-title">{{ res.question }}</a>
                    <div class="accordion-content" data-tab-content>
                        <p v-html="formatAnswer(res.answer)"></p>
                    </div>
                </li>
            </ul>
        </template>
        <template v-else-if="submitted && !loading && results.length == 0">
            <p>No answers could be found that address your question. Please try
                again or contact us via our <a href="/contact-us.html">Contact Form</a>
                or by mail:
            </p>
            <p>
                WSFS Bank, Attn: Corporate Trust<br>
                500 Delaware Ave, 11<sup>th</sup> Floor <br>
                Wilmington, DE 19801
            </p>
        </template>
        <template v-else-if="!submitted && !loading">
            <p class="spacer"></p>
        </template>
        <template v-else-if="loading">
            <p>Searching...</p>
            <p class="spacer"></p>
        </template>

        <div id="search-link" class="search-container" v-if="submitted && !loading">
            <button type="button" class="btn" @click.prevent="showModal=true">Search for a Servicer</button>
            <modal-search id="modal-search" v-if="showModal" @closed="modalClosed" />
        </div>
    </div>
</template>
<script>
import axios from 'axios'

import ModalSearch from './views/ModalSearch.vue'

export default {
    name: 'faqs-app',
    components: {ModalSearch},
    data() {
        return {
            question: '',
            results: [],
            kws: [],
            submitted: false,
            loading: false,
            showModal: false,
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        formatAnswer(input) {
            let out = input.replace(/\n/g, '<br>')
            out = out.replace(/trustee/g, '<dfn data-tooltip title="A Trustee is an independent party, responsible for administering the Trust for the benefit of Investors. While the Trustee is listed as the owner of record, the Trustee does not have an economic or beneficial interest in the loans. The Trustee is the owner of the mortgage solely for the benefit of the Investors in the mortgage-backed securities, who are the true beneficial owners of the mortgages. The duties of the Trustee are administrative in nature, and generally are non-discretionary.">trustee</dfn>')
            out = out.replace(/trusts/g, '<dfn data-tooltip title="A Trust is generally a special purpose entity, such as a Real Estate Mortgage Investment Conduit (REMIC), that is formed solely to hold the mortgage collateral and to issue the securities that are then sold to Investors. The Trust owns the pooled mortgages. The Trust conducts no other business.">trusts</dfn>')
            out = out.replace(/servicer/g, '<dfn data-tooltip title="The Servicer administers the mortgage loans and collects monthly payments. If a Borrower does not make payments to the Servicer as required by the mortgage documents, the Servicer may have to foreclose on the property and provide property maintenance. The Servicer does not own the mortgages/collateral. The Trustee does not designate the loan Servicers, nor are the loan Servicers agents of the Trustee.">servicer</dfn>')
            out = out.replace(/Contact Form/g, '<a href="/contact-us.html">Contact Form</a>')
            out = out.replace(/database/g, '<a href="#search-link" class="search-link">database</a>')
            return out
        },
        async submit() {
            this.loading = true
            this.results = []
            this.kws = []
            let r = await axios.get('/api/faqs/search', 
                {params: {q: this.question}})

            this.loading = false
            this.submitted = true
            if (r.status != 200 && r.status != 300) {
                this.results = [];
                this.kws = []
                return
            }

            this.results = r.data.results
            this.$nextTick(() => {
                $('#faqs-app').foundation()
            })
        },
        modalClosed() {
            this.showModal = false
        },
        async showAll() {
            let r = await axios.get('/api/faqs/search', 
                {params: {showall: true}})

            this.loading = false
            this.submitted = true
            if (r.status != 200 && r.status != 300) {
                this.results = [];
                this.kws = []
                return
            }

            this.results = r.data.results
            this.$nextTick(() => {
                $('#faqs-app').foundation()
            })
        }
    },
    mounted() {
        document.addEventListener('click', (event) => {
            if (event.target.matches('.search-link')) {
                this.showModal = true;
            }
        }, false);
    },
}
</script>
<style lang="scss">
#faqs-app {
    form {
        margin-bottom: 1.5rem;
    }

    p.spacer {
        height: 10rem;
    }

    .search-container {
        margin-top: 3rem;
    }

    dfn {
        border-bottom: dotted 1px #888;
        cursor: pointer;
        line-height: 1.15;
    }
}
</style>
